import config from "@/config/config";
import { KILL_START_DATE } from "@/constants/const";
import { getTimeRemaining } from "@/hook/useCycleCountdown";

export const isKillInitiationOpen = (nowMs: number) =>
  config.killInitiationContractEnabled &&
  (!KILL_START_DATE || nowMs >= KILL_START_DATE.getTime());

export const getKillLaunchCountdown = (nowMs: number) => {
  if (isKillInitiationOpen(nowMs)) {
    return { compact: "Now", full: "Live now", state: "live" as const };
  }

  if (!KILL_START_DATE) {
    return { compact: "Pending", full: "Date pending", state: "pending" as const };
  }

  if (nowMs >= KILL_START_DATE.getTime()) {
    return { compact: "Locked", full: "Activation pending", state: "pending" as const };
  }

  const { days, hours, minutes, seconds } = getTimeRemaining(KILL_START_DATE, nowMs);
  const hh = String(hours).padStart(2, "0");
  const mm = String(minutes).padStart(2, "0");
  const ss = String(seconds).padStart(2, "0");

  return {
    compact: days > 0 ? `${days}d ${hh}:${mm}:${ss}` : `${hh}:${mm}:${ss}`,
    full: `${days}d ${hh}h ${mm}m ${ss}s`,
    state: "counting" as const,
  };
};
